'use strict';

function CnHelpTextController($modal) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.openHelp = openHelp;

  function $onInit() {

  }

  function openHelp() {
    var modal = $modal({ template: require('./cn-help-text.modal.tpl.html'), show: true });
    modal.$scope.textKey = vm.textKey;
  }
}

module.exports = CnHelpTextController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-help-text/cn-help-text.controller.js
 ** module id = 130
 ** module chunks = 0
 **/